import { createSelector } from "@ngrx/store";

import { CoreState } from "../state";

import { LeftMenuState } from "./left-menu.model";

export namespace LeftMenuSelector {
	export const get = (state: CoreState): LeftMenuState => state?.leftMenu;

	export const isOpen = createSelector(get, (state): boolean => !!state?.isLeftMenuOpen);
}
